(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-marquee"] && !Shopify.designMode) return;
  try {
    
  // Logos outside the strip's clipped area never count as visible, so native lazy loading would make
  // them pop in as they slide into view. Load the whole strip once it comes near the viewport.
  (() => {
    const strips = document.querySelectorAll('.cl-marquee');
    if (!strips.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          for (const image of entry.target.querySelectorAll('img[loading="lazy"]')) image.loading = 'eager';
        }
      },
      { rootMargin: '400px 0px' }
    );
    strips.forEach((strip) => observer.observe(strip));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chexz-banner-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEPBanner(banner) {
    var track = banner.querySelector('.chexz-epbanner__track');
    if (!track) return;

    var origCards = Array.from(
      track.querySelectorAll('.chexz-epbanner__card:not([data-clone])')
    );
    var count = origCards.length;
    if (count < 2) return;

    /* Clone first N cards so the loop feels seamless */
    var cloneN = Math.min(count, 3);
    for (var i = 0; i < cloneN; i++) {
      var cl = origCards[i % count].cloneNode(true);
      cl.setAttribute('data-clone', 'true');
      cl.setAttribute('aria-hidden', 'true');
      track.appendChild(cl);
    }

    var current  = 0;
    var speed    = (parseInt(banner.dataset.speed, 10) || 4) * 1000;
    var isRTL    = document.documentElement.dir === 'rtl';

    function cardOffset() {
      var card = track.querySelector('.chexz-epbanner__card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    function goTo(idx, animate) {
      var sign = isRTL ? 1 : -1;
      track.style.transition = animate
        ? 'transform 0.65s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform =
        'translateX(' + sign * idx * cardOffset() + 'px)';
    }

    function advance() {
      current++;
      goTo(current, true);
      /* When we land on a clone, snap back silently */
      if (current >= count) {
        setTimeout(function () {
          current = 0;
          goTo(0, false);
        }, 700);
      }
    }

    var timer = setInterval(advance, speed);

    /* Pause on hover */
    banner.addEventListener('mouseenter', function () {
      clearInterval(timer);
    });
    banner.addEventListener('mouseleave', function () {
      timer = setInterval(advance, speed);
    });

    /* Recalculate on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(current, false); }, 100);
    });
  }

  function initAll() {
    document.querySelectorAll('.chexz-epbanner[data-speed]').forEach(initEPBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chexz-pdp"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   CHEXZ PDP — interactions
   ============================================================ */
(function () {
  "use strict";

  /* ---- Gallery ---- */
  var _idx = {};

  function shpdpGoTo(idx, sid) {
    var track  = document.getElementById('shpdp-track-' + sid);
    var thumbs = document.querySelectorAll('#shpdp-thumbs-' + sid + ' .shpdp-gallery__thumb');
    var dots   = document.querySelectorAll('#shpdp-dots-' + sid + ' .shpdp-gallery__dot');
    if (!track) return;

    var count = thumbs.length || dots.length || track.children.length || 1;
    if (idx === 'prev') idx = ((_idx[sid] || 0) - 1 + count) % count;
    if (idx === 'next') idx = ((_idx[sid] || 0) + 1) % count;

    _idx[sid] = idx;

    var width = track.offsetWidth || 300;
    track.scrollTo({ left: idx * width, behavior: 'smooth' });

    /* Match the stage aspect-ratio to the active slide's own image */
    var activeSlide = track.children[idx];
    var stage = document.getElementById('shpdp-stage-' + sid);
    if (stage && activeSlide && activeSlide.dataset.ar) {
      stage.style.setProperty('--shpdp-ar', activeSlide.dataset.ar);
    }

    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
  }
  window.shpdpGoTo = shpdpGoTo;

  /* Native Scroll Sync for Dots & Thumbnails */
  function initShpdpScrollSync() {
    document.querySelectorAll('.shpdp-gallery__track').forEach(function (track) {
      if (track.dataset.chexzScrollInited) return;
      track.dataset.chexzScrollInited = "true";

      var pdp = track.closest('[id^="shpdp-"]');
      if (!pdp) return;
      var sid = pdp.id.replace('shpdp-', '');
      var slides = track.querySelectorAll('.shpdp-gallery__slide');

      function updateActiveUI(idx) {
        if (typeof idx !== 'number' || idx < 0) return;
        _idx[sid] = idx;
        var thumbs = document.querySelectorAll('#shpdp-thumbs-' + sid + ' .shpdp-gallery__thumb');
        var dots   = document.querySelectorAll('#shpdp-dots-' + sid + ' .shpdp-gallery__dot');
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });

        /* Match the stage aspect-ratio to the active slide's own image */
        var stage = document.getElementById('shpdp-stage-' + sid);
        if (stage && slides[idx] && slides[idx].dataset.ar) {
          stage.style.setProperty('--shpdp-ar', slides[idx].dataset.ar);
        }
      }

      /* 1. Real-time IntersectionObserver */
      if ('IntersectionObserver' in window && slides.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = Array.prototype.indexOf.call(slides, entry.target);
              if (idx > -1) updateActiveUI(idx);
            }
          });
        }, { root: track, threshold: 0.51 });
        slides.forEach(function (slide) { io.observe(slide); });
      }

      /* 2. Instant scroll event fallback */
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            var width = track.offsetWidth || 1;
            var idx = Math.round(track.scrollLeft / width);
            updateActiveUI(idx);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    });
  }

  initShpdpScrollSync();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShpdpScrollSync);
  }
  document.addEventListener('shopify:section:load', initShpdpScrollSync);

  /* ---- Variant selection ---- */
  window._shpdpVariants = window._shpdpVariants || {};

  function shpdpSelectOption(btn, sid) {
    var optIdx = parseInt(btn.dataset.optionIndex, 10);
    var value  = btn.dataset.value;

    /* Mark active pill in this option row */
    var row = btn.closest('.shpdp-pills');
    if (row) row.querySelectorAll('.shpdp-pill').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.value === value);
    });

    /* Update display label */
    var lbl = document.getElementById('shpdp-pick-' + sid + '-' + optIdx);
    if (lbl) lbl.textContent = value;

    /* Find matching variant */
    var allPills = document.querySelectorAll('#shpdp-form-' + sid + ' .shpdp-pills');
    var chosen = [];
    allPills.forEach(function (grp) {
      var active = grp.querySelector('.shpdp-pill.is-active');
      chosen.push(active ? active.dataset.value : null);
    });

    var variants = window['chexzVariants_' + sid] || [];
    var matched = variants.find(function (v) {
      return chosen.every(function (val, i) { return val === null || v['option' + (i + 1)] === val; });
    });

    if (matched) {
      if (typeof matched.image_index === 'number' && matched.image_index > -1) {
        shpdpGoTo(matched.image_index, sid);
      }

      var vidEl = document.getElementById('shpdp-vid-' + sid);
      if (vidEl) vidEl.value = matched.id;

      var nowEl = document.getElementById('shpdp-price-now-' + sid);
      if (nowEl) nowEl.textContent = matched.price_formatted;

      var sizeEl = document.getElementById('shpdp-price-size-' + sid);
      if (sizeEl) sizeEl.textContent = (matched.options && matched.options[0]) || matched.option1 || matched.title || '';

      var wasEl = document.getElementById('shpdp-price-was-' + sid);
      if (wasEl) wasEl.textContent = matched.compare_at_price > 0 ? matched.compare_at_price_formatted : '';

      var stickyP = document.getElementById('shpdp-sticky-price-' + sid);
      if (stickyP) stickyP.textContent = matched.price_formatted;

      var atcBtn    = document.getElementById('shpdp-atc-' + sid);
      var lbl       = document.getElementById('shpdp-atc-label-' + sid);
      var stickyBtn = document.getElementById('shpdp-sticky-atc-' + sid);
      var buyNowBtn = document.getElementById('shpdp-buynow-' + sid);
      var isAr      = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';

      if (!matched.available) {
        if (atcBtn) atcBtn.disabled = true;
        if (lbl) lbl.textContent = isAr ? 'نفد المخزون' : 'Out of Stock';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.setAttribute('title', isAr ? 'نفد المخزون' : 'Out of Stock'); }
        if (buyNowBtn) buyNowBtn.disabled = true;
      } else {
        if (atcBtn) atcBtn.disabled = false;
        if (lbl) lbl.textContent = isAr ? 'أضف إلى السلة' : 'Add to Cart';
        if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.setAttribute('title', isAr ? 'أضف إلى السلة' : 'Add to Cart'); }
        if (buyNowBtn) buyNowBtn.disabled = false;
      }
    }
  }
  window.shpdpSelectOption = shpdpSelectOption;

  /* ---- Quantity ---- */
  function shpdpQty(delta, sid) {
    var input = document.getElementById('shpdp-qty-' + sid);
    if (!input) return;
    var val = parseInt(input.value) + delta;
    input.value = Math.max(1, Math.min(99, val));
  }
  window.shpdpQty = shpdpQty;

  /* ---- Toast ---- */
  var _toastT = {};
  function shpdpToast(msg, sid) {
    var toast = document.getElementById('shpdp-toast-' + sid);
    var span  = document.getElementById('shpdp-toast-msg-' + sid);
    if (!toast) return;
    if (msg && span) span.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(_toastT[sid]);
    _toastT[sid] = setTimeout(function () { toast.classList.remove('is-show'); }, 2400);
  }

  /* ---- Add to Cart ----
     Goes through window.chexzCartAdd (assets/chexz-cart-bridge.js) so the drawer, the cart
     page and the cart bubble re-render immediately instead of only after a page refresh. */
  function shpdpAddToCart(sid) {
    var vidEl  = document.getElementById('shpdp-vid-' + sid);
    var qtyEl  = document.getElementById('shpdp-qty-' + sid);
    var btn    = document.getElementById('shpdp-atc-' + sid);
    var sBtn   = document.getElementById('shpdp-sticky-atc-' + sid);
    if (!vidEl) return;
    if (btn && btn.disabled) return;

    var qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    [btn, sBtn].forEach(function (b) { if (b) { b.classList.add('loading'); b.disabled = true; } });

    window.chexzCartAdd({ id: parseInt(vidEl.value), quantity: qty }, { source: 'chexz-pdp' })
      .then(function () {
        var isAr = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';
        [btn, sBtn].forEach(function (b) {
          if (!b) return;
          b.classList.remove('loading');
          b.classList.add('added');
          setTimeout(function () { b.classList.remove('added'); b.disabled = false; }, 1400);
        });
        shpdpToast(isAr ? 'تمت الإضافة للسلة ✓' : 'Added to cart ✓', sid);
      })
      .catch(function () {
        [btn, sBtn].forEach(function (b) { if (b) { b.classList.remove('loading'); b.disabled = false; } });
      });
  }
  window.shpdpAddToCart = shpdpAddToCart;

  /* ---- Buy Now ---- */
  function shpdpBuyNow(sid) {
    var vidEl = document.getElementById('shpdp-vid-' + sid);
    var qtyEl = document.getElementById('shpdp-qty-' + sid);
    if (!vidEl) return;
    var qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vidEl.value), quantity: qty })
    }).then(function () { window.location = '/checkout'; })
      .catch(function ()  { window.location = '/checkout'; });
  }
  window.shpdpBuyNow = shpdpBuyNow;

  /* ---- Wishlist ----
     The heart carries data-cl-wish, so assets/cl-delight.js saves it in the shared store (cl_wish, mirrored
     to chexz_wish), keeps aria-pressed in sync, bursts the hearts and shows the toast. Kept for callers. */
  function shpdpToggleWish(sid) {
    var btn = document.getElementById('shpdp-wish-' + sid);
    if (btn) btn.click();
  }
  window.shpdpToggleWish = shpdpToggleWish;

  /* ---- Accordions ---- */
  function shpdpAccToggle(btn) {
    btn.closest('.shpdp-acc__item').classList.toggle('is-open');
  }
  window.shpdpAccToggle = shpdpAccToggle;

  /* ---- Sticky bar (IntersectionObserver) ---- */
  document.querySelectorAll('[id^="shpdp-action-"]').forEach(function (actionRow) {
    var sid = actionRow.id.replace('shpdp-action-', '');
    var sticky = document.getElementById('shpdp-sticky-' + sid);
    if (!sticky) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });
    io.observe(actionRow);
  });

})();

/* ================================================================
   REVIEWS — localStorage display + contact form notification
   ================================================================ */
(function () {
  "use strict";

  var starLabels = {
    ar: ['', 'مزعج', 'سيء', 'مقبول', 'جيد', 'ممتاز'],
    en: ['', 'Poor',  'Fair', 'Good',  'Very Good', 'Excellent']
  };

  var starSvgFull  = '<svg viewBox="0 0 24 24" fill="var(--sh-caramel)"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L4.5 9.7l5.9-.9L12 3.5z"/></svg>';
  var starSvgEmpty = '<svg viewBox="0 0 24 24" fill="var(--sh-line-strong)"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L4.5 9.7l5.9-.9L12 3.5z"/></svg>';

  /* ---- localStorage helpers ---- */
  function revKey(pid) { return 'chexz_revs_' + pid; }
  function getRevs(pid) { try { return JSON.parse(localStorage.getItem(revKey(pid)) || '[]'); } catch(e) { return []; } }
  function saveRev(pid, r) { var l = getRevs(pid); l.unshift(r); localStorage.setItem(revKey(pid), JSON.stringify(l)); }

  window.shpdpDelRev = function(sid, pid, idx) {
    var revs = getRevs(pid);
    revs.splice(idx, 1);
    localStorage.setItem(revKey(pid), JSON.stringify(revs));
    renderList(sid, pid);
  };

  /* ---- Render helpers ---- */
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function starsRow(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += (i <= n ? starSvgFull : starSvgEmpty);
    return h;
  }

  function fmtDate(iso, isAr) {
    try { return new Date(iso).toLocaleDateString(isAr ? 'ar-EG' : 'en-GB', {year:'numeric', month:'short', day:'numeric'}); }
    catch(e) { return ''; }
  }

  /* ---- Update inline rating (above product title) ---- */
  function updateInlineRating(sid, avg, count, isAr) {
    var starsEl = document.getElementById('shpdp-inline-stars-' + sid);
    var valEl   = document.getElementById('shpdp-rate-val-'    + sid);
    var cntEl   = document.getElementById('shpdp-rate-cnt-'    + sid);
    if (starsEl) starsEl.innerHTML  = starsRow(Math.round(avg));
    if (valEl)   valEl.textContent  = avg.toFixed(1);
    if (cntEl)   cntEl.textContent  = isAr ? count + ' تقييم' : count + ' reviews';
  }

  /* ---- Render review cards ---- */
  function renderList(sid, pid) {
    var isAr    = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    var listEl  = document.getElementById('shpdp-rev-list-' + sid);
    var section = document.getElementById('shpdp-reviews-' + sid);
    var isAdmin = section && section.dataset.isAdmin === 'true';
    if (!listEl) return;

    var revs = getRevs(pid);

    if (revs.length) {
      var sum = revs.reduce(function(a, r) { return a + parseInt(r.rating); }, 0);
      updateInlineRating(sid, sum / revs.length, revs.length, isAr);

      listEl.innerHTML = revs.map(function(r, i) {
        var delBtn = isAdmin
          ? '<button class="shpdp-revcard__del" onclick="shpdpDelRev(\'' + sid + '\',\'' + pid + '\',' + i + ')" aria-label="حذف">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
            + '</button>'
          : '';
        return '<div class="shpdp-revcard" data-idx="' + i + '">'
          + '<div class="shpdp-revcard__top">'
          + '<div class="shpdp-revcard__mono">' + esc(r.name).charAt(0).toUpperCase() + '</div>'
          + '<div class="shpdp-revcard__meta"><b>' + esc(r.name) + '</b><small>' + fmtDate(r.date, isAr) + '</small></div>'
          + '<div class="shpdp-revcard__stars">' + '★'.repeat(r.rating) + '<span style="opacity:.3">' + '★'.repeat(5 - r.rating) + '</span></div>'
          + delBtn
          + '</div>'
          + '<p class="shpdp-revcard__body">' + esc(r.body) + '</p>'
          + '</div>';
      }).join('');
    } else {
      listEl.innerHTML = '<div class="shpdp-rev-list__empty">'
        + (isAr ? 'لا توجد تقييمات بعد' : 'No reviews yet')
        + '</div>';
    }
  }

  /* Init on page load */
  document.querySelectorAll('[id^="shpdp-reviews-"]').forEach(function(el) {
    var sid = el.id.replace('shpdp-reviews-', '');
    var pid = el.dataset.productId;
    if (pid) renderList(sid, pid);
  });

  /* ---- Open / close form ---- */
  window.shpdpOpenRevForm = function(sid) {
    var el = document.getElementById('shpdp-revform-' + sid);
    if (!el) return;
    el.removeAttribute('hidden');
    setTimeout(function() { el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
  };

  window.shpdpCloseRevForm = function(sid) {
    var el = document.getElementById('shpdp-revform-' + sid);
    if (el) el.setAttribute('hidden', '');
  };

  /* ---- Star picker ---- */
  window.shpdpSetStar = function(val, sid) {
    var input = document.getElementById('shpdp-rev-rating-' + sid);
    var stars = document.querySelectorAll('#shpdp-rev-stars-' + sid + ' .shpdp-revform__star');
    var hint  = document.getElementById('shpdp-rev-hint-' + sid);
    var isAr  = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    if (input) input.value = val;
    stars.forEach(function(s, i) { s.classList.toggle('is-active', i < val); });
    if (hint) { hint.style.color = ''; hint.textContent = (isAr ? starLabels.ar : starLabels.en)[val] || ''; }
  };

  document.querySelectorAll('[id^="shpdp-rev-stars-"]').forEach(function(wrap) {
    var stars = wrap.querySelectorAll('.shpdp-revform__star');
    stars.forEach(function(star, idx) {
      star.addEventListener('mouseenter', function() { stars.forEach(function(s,i){ s.classList.toggle('is-hover', i<=idx); }); });
      star.addEventListener('mouseleave', function() { stars.forEach(function(s){ s.classList.remove('is-hover'); }); });
    });
  });

  /* ---- Submit ---- */
  window.shpdpSubmitRev = function(e, sid) {
    e.preventDefault();
    var isAr   = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    var rating = document.getElementById('shpdp-rev-rating-' + sid);
    var hint   = document.getElementById('shpdp-rev-hint-'   + sid);
    var nameEl = document.getElementById('shpdp-rev-name-'   + sid);
    var emailEl= document.getElementById('shpdp-rev-email-'  + sid);
    var bodyEl = document.getElementById('shpdp-rev-body-'   + sid);
    var submit = document.getElementById('shpdp-rev-submit-' + sid);

    if (!rating || !rating.value) {
      if (hint) { hint.style.color = '#c0392b'; hint.textContent = isAr ? 'الرجاء اختيار عدد النجوم' : 'Please select a star rating'; }
      return;
    }

    var pid = document.getElementById('shpdp-reviews-' + sid).dataset.productId;
    var prod     = (document.querySelector('[name="review[product]"]')       || {}).value || '';
    var prodUrl  = (document.querySelector('[name="review[product_url]"]')   || {}).value || '';
    var prodImg  = (document.querySelector('[name="review[product_image]"]') || {}).value || '';

    /* 1 — Save to localStorage & render immediately */
    saveRev(pid, {
      name:      nameEl.value.trim(),
      rating:    parseInt(rating.value),
      body:      bodyEl.value.trim(),
      date:      new Date().toISOString(),
      product:   prod,
      productUrl: prodUrl,
      productImg: prodImg
    });
    renderList(sid, pid);

    /* 2 — Send contact email to admin */
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', emailEl ? emailEl.value : 'review@store.com');
    fd.append('contact[name]',  nameEl.value.trim());
    fd.append('contact[body]',
      '⭐ ' + rating.value + '/5\n📦 ' + prod + '\n\n' + bodyEl.value.trim()
    );
    fetch('/contact', { method: 'POST', body: fd });

    /* 3 — Reset & close */
    rating.value = ''; nameEl.value = ''; bodyEl.value = '';
    if (emailEl) emailEl.value = '';
    document.querySelectorAll('#shpdp-rev-stars-' + sid + ' .shpdp-revform__star').forEach(function(s){ s.classList.remove('is-active'); });
    if (hint) hint.textContent = isAr ? 'اختر عدد النجوم' : 'Select a rating';
    document.getElementById('shpdp-revform-' + sid).setAttribute('hidden', '');
    shpdpToast(isAr ? 'تم نشر تقييمك ✓' : 'Review published ✓', sid);
  };

})();

/* ================================================================
   LIGHTBOX
   ================================================================ */
(function () {
  "use strict";

  var _lbIdx   = {};
  var _lbTotal = {};

  function lbTrack(sid) { return document.getElementById('shpdp-lb-track-' + sid); }
  function lbEl(sid)    { return document.getElementById('shpdp-lb-' + sid); }

  function lbSyncUI(sid) {
    var idx = _lbIdx[sid] || 0;
    var cur = document.getElementById('shpdp-lb-cur-' + sid);
    if (cur) cur.textContent = idx + 1;
    var dots = document.querySelectorAll('#shpdp-lb-dots-' + sid + ' .shpdp-lb__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  function lbSlideTo(sid, idx) {
    _lbIdx[sid] = idx;
    var t = lbTrack(sid);
    if (t) t.style.transform = 'translateX(' + (idx * -100) + '%)';
    lbSyncUI(sid);
  }

  window.shpdpOpenLb = function (sid, idx) {
    if (window._chexzSwipeLock) return;
    _lbTotal[sid] = document.querySelectorAll('#shpdp-lb-track-' + sid + ' .shpdp-lb__slide').length;
    var t = lbTrack(sid);
    if (t) { t.style.transition = 'none'; t.style.transform = 'translateX(' + (idx * -100) + '%)'; }
    _lbIdx[sid] = idx;
    lbSyncUI(sid);
    requestAnimationFrame(function () {
      if (t) t.style.transition = 'transform .4s cubic-bezier(.22,1,.36,1)';
    });
    var el = lbEl(sid);
    // A sticky/transformed ancestor traps position:fixed; the lightbox must live on <body> to cover the screen.
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
    if (el) { el.classList.add('is-open'); el.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden'; }
  };

  window.shpdpCloseLb = function (sid) {
    var el = lbEl(sid);
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  };

  window.shpdpLbBgClick = function (e, sid) {
    if (e.target === e.currentTarget) shpdpCloseLb(sid);
  };

  window.shpdpLbNav = function (sid, dir) {
    var total = _lbTotal[sid] || document.querySelectorAll('#shpdp-lb-track-' + sid + ' .shpdp-lb__slide').length;
    lbSlideTo(sid, ((_lbIdx[sid] || 0) + dir + total) % total);
  };

  window.shpdpLbGoTo = function (sid, idx) {
    lbSlideTo(sid, idx);
  };

  /* Keyboard */
  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.shpdp-lb.is-open');
    if (!open) return;
    var sid = open.id.replace('shpdp-lb-', '');
    if (e.key === 'Escape')     shpdpCloseLb(sid);
    if (e.key === 'ArrowLeft')  shpdpLbNav(sid, -1);
    if (e.key === 'ArrowRight') shpdpLbNav(sid,  1);
  });

  /* Touch swipe inside lightbox */
  var _lbSx = null;
  document.addEventListener('touchstart', function (e) {
    var open = document.querySelector('.shpdp-lb.is-open');
    if (open && open.contains(e.target)) _lbSx = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (_lbSx === null) return;
    var open = document.querySelector('.shpdp-lb.is-open');
    if (!open) { _lbSx = null; return; }
    var dx = e.changedTouches[0].clientX - _lbSx;
    _lbSx = null;
    if (Math.abs(dx) < 40) return;
    shpdpLbNav(open.id.replace('shpdp-lb-', ''), dx < 0 ? 1 : -1);
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-collections-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const input = root.querySelector('[data-cl-cx-search]');
      if (!input || input.dataset.ready) return;
      input.dataset.ready = 'true';
      const groups = [...root.querySelectorAll('[data-cl-cx-group]')];
      const empty = root.querySelector('[data-cl-cx-empty]');
      input.addEventListener('input', () => {
        const term = input.value.trim().toLowerCase();
        let shown = 0;
        for (const group of groups) {
          let inGroup = 0;
          for (const item of group.querySelectorAll('[data-cl-cx-item]')) {
            const match = !term || (item.dataset.name || '').includes(term);
            item.hidden = !match;
            if (match) inGroup += 1;
          }
          group.hidden = inGroup === 0;
          shown += inGroup;
        }
        if (empty) empty.hidden = shown > 0;
      });
    };
    document.querySelectorAll('[data-cl-cx]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-cl-cx]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-hero-slider')) {
    class ClHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.cl-hero__slide'));
        if (this.slides.length < 2) return;
        this.dots = Array.from(this.querySelectorAll('[data-cl-dot]'));
        this.toggleButton = this.querySelector('[data-cl-toggle]');
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 6000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.dataset.autoplay !== 'true' || this.reduceMotion;
        this.hoverPaused = false;

        this.querySelector('[data-cl-prev]')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-cl-next]')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.clDot))));
        this.toggleButton?.addEventListener('click', () => this.setUserPaused(!this.userPaused));

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.setHoverPaused(true);
        });
        this.addEventListener('pointerleave', () => this.setHoverPaused(false));
        this.addEventListener('focusin', () => this.setHoverPaused(true));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setHoverPaused(false);
        });
        this.addEventListener('keydown', (event) => {
          const rtl = document.documentElement.dir === 'rtl';
          if (event.key === 'ArrowRight') this.go(this.index + (rtl ? -1 : 1));
          if (event.key === 'ArrowLeft') this.go(this.index + (rtl ? 1 : -1));
        });

        // Swipe with a finger or drag with the mouse (Kenan 2026-10-10: «وأقدر قلّب بإيدي»).
        // The section has touch-action: pan-y, so vertical scrolling stays native.
        let drag = null;
        let suppressClick = false;
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('.cl-hero__controls')) return;
          drag = { x: event.clientX, y: event.clientY, id: event.pointerId, moved: false };
        });
        this.addEventListener('pointermove', (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          if (!drag.moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
            drag.moved = true;
            this.classList.add('is-dragging');
            this.setPointerCapture?.(event.pointerId);
          }
        });
        const endDrag = (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          const moved = drag.moved;
          drag = null;
          this.classList.remove('is-dragging');
          if (!moved || event.type === 'pointercancel') return;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
          suppressClick = true;
          const rtl = document.documentElement.dir === 'rtl';
          this.go(this.index + ((dx < 0) !== rtl ? 1 : -1));
        };
        this.addEventListener('pointerup', endDrag);
        this.addEventListener('pointercancel', endDrag);
        // A drag that changed the slide must not also follow the slide's link or button.
        this.addEventListener(
          'click',
          (event) => {
            if (!suppressClick) return;
            suppressClick = false;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
        // Firefox ignores -webkit-user-drag: stop the native image drag ghost.
        this.addEventListener('dragstart', (event) => event.preventDefault());

        this.onVisibility = () => this.schedule();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.syncToggle();
        this.publishTone();
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(next) {
        const count = this.slides.length;
        const target = (next + count) % count;
        if (target === this.index) return;
        this.hydrate(target);
        this.hydrate(target + 1);
        const current = this.slides[this.index];
        const incoming = this.slides[target];
        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        current.inert = true;
        incoming.classList.add('is-active');
        incoming.removeAttribute('aria-hidden');
        incoming.inert = false;
        this.dots.forEach((dot, i) => {
          if (i === target) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.index = target;
        this.publishTone();
        this.schedule();
      }

      /** Gives a deferred slide its real image sources (see the Liquid above). */
      hydrate(i) {
        const slide = this.slides[(i + this.slides.length) % this.slides.length];
        if (!slide) return;
        for (const el of slide.querySelectorAll('[data-srcset], [data-src]')) {
          if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
          if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
        }
      }

      publishTone() {
        const tone = this.slides[this.index].classList.contains('cl-hero__slide--dark') ? 'dark' : 'light';
        document.documentElement.dataset.clHeroTone = tone;
        this.dataset.tone = tone;
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.userPaused || this.hoverPaused || document.hidden) return;
        // Fetch the next slide shortly before it is due, not with the page.
        clearTimeout(this.warmTimer);
        this.warmTimer = setTimeout(() => this.hydrate(this.index + 1), Math.max(0, this.interval - 2500));
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }

      setHoverPaused(value) {
        this.hoverPaused = value;
        this.classList.toggle('is-holding', value);
        this.schedule();
      }

      setUserPaused(value) {
        this.userPaused = value;
        this.syncToggle();
        this.schedule();
      }

      syncToggle() {
        this.classList.toggle('is-paused', this.userPaused);
        if (!this.toggleButton) return;
        const label = this.userPaused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause;
        this.toggleButton.setAttribute('aria-label', label);
      }
    }

    customElements.define('cl-hero-slider', ClHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-offer-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(root) {
      if (!root || root.classList.contains('is-armed')) return;
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var rect = root.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              root.classList.add('is-in');
              io.disconnect();
              break;
            }
          }
        },
        { rootMargin: '0px 0px -12% 0px' }
      );
      io.observe(root);
    }

    function init(scope) {
      var list = (scope || document).querySelectorAll('.cl-offer');
      for (var i = 0; i < list.length; i++) arm(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-support"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cl-support')) return;

    const I = {
      damaged: '<path d="M9 2h6v3l2 2v13a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V7l2-2z"/><path d="m10 11 2 2-1.5 2 2.5 2"/>',
      wrong_item: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3.3 7.5 8.7 5 8.7-5M12 22V12"/><path d="m15 9-6 6"/>',
      return: '<path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/>',
      exchange: '<path d="m17 2 4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="m7 22-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/>',
      authenticity: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/>',
      delivery: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
      cancel_edit: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
      refund_missing: '<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/>',
      complaint: '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
      check: '<path d="M20 6 9 17l-5-5"/>',
      arrow: '<path d="m15 18-6-6 6-6"/>',
    };
    const svg = (k) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${I[k] || ''}</svg>`;
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    // order: the most common problems first (from the store's DMs, Oct 2026).
    const ORDER = ['damaged', 'wrong_item', 'return', 'exchange', 'authenticity', 'delivery', 'cancel_edit', 'refund_missing', 'complaint'];
    const T = {
      ar: {
        types: {
          damaged: ['منتج وصل تالف أو مسرّب', 'ازازة مكسورة أو مسرّبة أو علبة متضررة'],
          wrong_item: ['منتج غلط أو ناقص', 'وصلك عطر غير اللي طلبته، أو حاجة ناقصة'],
          return: ['استرجاع', 'المنتج مقفول بختمه الأصلي'],
          exchange: ['استبدال', 'بعطر بنفس القيمة أو أعلى، والمنتج غير مستخدم'],
          authenticity: ['شك في أصالة المنتج', 'قبل الاستخدام، مع صور العلبة والباركود'],
          delivery: ['الطلب ما وصل أو متأخر', 'تأخير، مشكلة مع المندوب، أو تعديل العنوان'],
          cancel_edit: ['إلغاء أو تعديل الطلب', 'قبل ما الطلب يتشحن'],
          refund_missing: ['استرداد مبلغ ما وصلني', 'اتوافق على الاسترداد ولسه المبلغ ما وصل'],
          complaint: ['شكوى أو اقتراح', 'أي حاجة تانية تحب تقولها لنا'],
        },
        status: { received: 'وصلنا طلبك', reviewing: 'قيد المراجعة', needs_info: 'محتاجين منك معلومة', approved: 'تمت الموافقة', pickup: 'المندوب جاي يستلم المنتج', processing: 'جاري التنفيذ', resolved: 'تم الحل', rejected: 'ما قدرنا نقبل الطلب' },
        hello: (n, o) => (n ? `أهلاً ${n}، ` : 'أهلاً، ') + `ده الأوردر ${o}. إيه المشكلة؟`,
        typeTitle: 'اختار نوع المشكلة',
        openNote: (list) => `عندك طلب دعم مفتوح على الأوردر ده: ${list}. تقدر تتابعه من «تابع طلبك» بدل ما تفتح طلب جديد.`,
        late: 'انتهت المدة',
        back: 'رجوع',
        windowOut: (h) => `حسب سياسة الاسترجاع، المدة المسموحة ${h} من الاستلام وانتهت. تقدر تبعت الطلب وفريقنا هيراجعه، لكن القبول مش مضمون.`,
        windowIn: (d) => `طلبك داخل المدة المسموحة، لحد ${d}.`,
        shipped: 'الأوردر ده اتشحن بالفعل، فممكن ما نقدرش نلغيه أو نعدّله. ابعت طلبك وهنشوف المتاح.',
        items: 'أي منتج؟',
        wishExchange: 'عايز تستبدله بإيه؟',
        wishExchangePh: 'اسم العطر أو الحجم اللي عايزه',
        wishCancel: 'عايز تلغي ولا تعدّل إيه بالظبط؟',
        wishCancelPh: 'مثال: إلغاء الأوردر كله / تغيير العنوان / تغيير الحجم',
        resolution: 'تحب نعمل إيه؟',
        res: { replace: 'استبدال بمنتج سليم', refund: 'استرداد المبلغ' },
        refund: 'نرجّعلك المبلغ على',
        refundMethods: { instapay: 'إنستاباي', vodafone_cash: 'فودافون كاش' },
        account: 'رقم المحفظة أو عنوان إنستاباي',
        accountPh: '01xxxxxxxxx أو name@instapay',
        details: 'احكيلنا اللي حصل',
        detailsPh: 'كل ما كانت التفاصيل أوضح، كل ما قدرنا نحلها أسرع.',
        photos: 'صور المنتج والعلبة',
        photosReq: '(مطلوبة)',
        photosOpt: '(اختياري)',
        photosHint: { damaged: 'صوّر الازازة والعلبة وكرتونة الشحن من أكتر من زاوية.', wrong_item: 'صوّر المنتج اللي وصلك وبوليصة الشحن.', authenticity: 'صوّر قاع العلبة (الباركود ورقم التشغيلة) والازازة.' },
        drop: '<b>اضغط لإضافة صور</b> أو اسحبها هنا · لحد 4 صور',
        name: 'اسمك',
        contact: 'نتواصل معاك إزاي لو احتجنا؟',
        contacts: { whatsapp: 'واتساب', call: 'مكالمة' },
        submit: 'إرسال الطلب',
        sending: 'جاري الإرسال…',
        doneTitle: 'وصلنا طلبك',
        doneExisting: 'عندك طلب مفتوح بنفس المشكلة، فضفنا رسالتك عليه.',
        doneText: (h) => `فريق الدعم هيرد على حضرتك خلال ${h} في ساعات العمل. تقدر تتابع طلبك في أي وقت من «تابع طلبك» برقم الأوردر ورقم موبايلك، وأي رد مننا هيظهر لك هناك تلقائياً.`,
        ref: 'رقم المرجع',
        liveNew: 'وصل تحديث جديد على طلبك',
        copy: 'نسخ', copied: 'اتنسخ',
        trackIt: 'تابع الطلب',
        newOne: 'طلب جديد',
        hours: (h) => (h <= 2 ? 'ساعتين' : h < 24 ? `${h} ساعات` : 'يوم عمل'),
        winH: (h) => (h > 48 ? `${h / 24} يوم` : `${h} ساعة`),
        opened: 'اتفتح', updated: 'آخر تحديث',
        created: 'وصلنا طلبك', you: 'رسالتك', team: 'رسالة من فريق الدعم',
        addTitle: 'عايز تضيف معلومة أو صور؟',
        addPh: 'اكتب رسالتك هنا',
        addSend: 'إرسال',
        addDone: 'اتبعتت، فريقنا هيشوفها.',
        closed: 'الطلب ده اتقفل. لو المشكلة لسه موجودة افتح طلب جديد.',
        err: {
          no_match: 'رقم الأوردر أو الموبايل مش مطابق. اكتب رقم الأوردر زي ما وصلك (مثال 1542 أو MO-1068) ورقم الموبايل اللي طلبت بيه.',
          no_match_track: 'ما لقيناش طلب دعم على الأوردر ده بالموبايل ده. اكتب رقم الأوردر زي ما وصلك (مثال 1542 أو MO-1068) ونفس الموبايل اللي قدّمت بيه الطلب.',
          rate_limited: 'محاولات كتير ورا بعض. استنى شوية وجرّب تاني.',
          photos: 'الصور لازم تكون JPG أو PNG، ولحد 4 صور.',
          photos_required: 'ضيف صورة واحدة على الأقل للمنتج والعلبة.',
          fields: 'اكتب اسمك واحكيلنا المشكلة (10 حروف على الأقل).',
          refund: 'اختار طريقة الاسترداد واكتب رقم المحفظة أو عنوان إنستاباي.',
          wish: 'اكتب العطر اللي عايز تستبدل بيه.',
          empty: 'اكتب رسالة أو ضيف صورة.',
          closed: 'الطلب ده اتقفل.',
          network: 'في مشكلة في الاتصال. تأكد من الإنترنت وجرّب تاني.',
          server: 'حصلت مشكلة عندنا. جرّب تاني بعد دقيقة، أو كلّمنا على واتساب.',
          need: 'اكتب رقم الأوردر ورقم الموبايل.',
          needTrack: 'اكتب رقم الأوردر ورقم الموبايل.',
          items: 'اختار المنتج اللي فيه المشكلة.',
        },
      },
      en: {
        types: {
          damaged: ['Damaged or leaking bottle', 'Broken or leaking bottle, or a damaged box'],
          wrong_item: ['Wrong or missing item', 'You received a different perfume, or something is missing'],
          return: ['Return', 'The product is still sealed'],
          exchange: ['Exchange', 'For a perfume of the same or higher value, unused'],
          authenticity: ['Authenticity check', 'Before use, with photos of the box and barcode'],
          delivery: ['Order late or not delivered', 'Delays, courier issues or an address change'],
          cancel_edit: ['Cancel or change my order', 'Before the order ships'],
          refund_missing: ['Refund not received', 'Your refund was approved but has not arrived'],
          complaint: ['Complaint or feedback', 'Anything else you want to tell us'],
        },
        status: { received: 'Request received', reviewing: 'Under review', needs_info: 'We need more information', approved: 'Approved', pickup: 'Courier pickup scheduled', processing: 'In progress', resolved: 'Resolved', rejected: "We couldn't accept this request" },
        hello: (n, o) => (n ? `Hello ${n}, ` : 'Hello, ') + `this is order ${o}. What went wrong?`,
        typeTitle: 'Choose the issue',
        openNote: (list) => `You already have an open request for this order: ${list}. You can follow it under “Track a request” instead of opening a new one.`,
        late: 'Period ended',
        back: 'Back',
        windowOut: (h) => `Under our return policy this request must be made within ${h} of delivery, and that period has passed. You can still send it and our team will review it, but approval isn't guaranteed.`,
        windowIn: (d) => `You're within the allowed period, until ${d}.`,
        shipped: "This order has already shipped, so we may not be able to cancel or change it. Send your request and we'll see what's possible.",
        items: 'Which product?',
        wishExchange: 'What would you like instead?',
        wishExchangePh: 'Perfume name or size you want',
        wishCancel: 'What exactly do you want to cancel or change?',
        wishCancelPh: 'e.g. cancel the whole order / change the address / change the size',
        resolution: 'What would you like us to do?',
        res: { replace: 'Send a replacement', refund: 'Refund me' },
        refund: 'Refund to',
        refundMethods: { instapay: 'InstaPay', vodafone_cash: 'Vodafone Cash' },
        account: 'Wallet number or InstaPay address',
        accountPh: '01xxxxxxxxx or name@instapay',
        details: 'Tell us what happened',
        detailsPh: 'The clearer the details, the faster we can fix it.',
        photos: 'Photos of the product and box',
        photosReq: '(required)',
        photosOpt: '(optional)',
        photosHint: { damaged: 'Photograph the bottle, the box and the shipping carton from several angles.', wrong_item: 'Photograph the product you received and the shipping label.', authenticity: 'Photograph the bottom of the box (barcode and batch number) and the bottle.' },
        drop: '<b>Tap to add photos</b> or drag them here · up to 4',
        name: 'Your name',
        contact: 'How should we reach you if needed?',
        contacts: { whatsapp: 'WhatsApp', call: 'Phone call' },
        submit: 'Send request',
        sending: 'Sending…',
        doneTitle: "We've received your request",
        doneExisting: 'You already had an open request for the same issue, so we added your message to it.',
        doneText: (h) => `Our support team will reply within ${h} during working hours. You can follow your request any time under “Track a request” with your order number and mobile, and our replies will appear there automatically.`,
        ref: 'Reference',
        liveNew: 'There is a new update on your request',
        copy: 'Copy', copied: 'Copied',
        trackIt: 'Track request',
        newOne: 'New request',
        hours: (h) => (h <= 2 ? '2 hours' : h < 24 ? `${h} hours` : 'one working day'),
        winH: (h) => (h > 48 ? `${h / 24} days` : `${h} hours`),
        opened: 'Opened', updated: 'Last update',
        created: 'Request received', you: 'Your message', team: 'Message from our support team',
        addTitle: 'Want to add information or photos?',
        addPh: 'Write your message here',
        addSend: 'Send',
        addDone: 'Sent. Our team will see it.',
        closed: 'This request is closed. If the problem is still there, open a new request.',
        err: {
          no_match: "The order number and mobile number don't match. Enter the order number as you received it (e.g. 1542 or MO-1068) and the mobile number you ordered with.",
          no_match_track: "We couldn't find a support request on that order with that mobile. Enter the order number as you received it (e.g. 1542 or MO-1068) and the mobile you used for the request.",
          rate_limited: 'Too many attempts. Please wait a little and try again.',
          photos: 'Photos must be JPG or PNG, up to 4.',
          photos_required: 'Add at least one photo of the product and the box.',
          fields: 'Enter your name and describe the problem (at least 10 characters).',
          refund: 'Choose a refund method and enter your wallet number or InstaPay address.',
          wish: 'Tell us which perfume you want instead.',
          empty: 'Write a message or add a photo.',
          closed: 'This request is closed.',
          network: 'Connection problem. Check your internet and try again.',
          server: 'Something went wrong on our side. Try again in a minute, or message us on WhatsApp.',
          need: 'Enter the order number and the mobile number.',
          needTrack: 'Enter the order number and the mobile number.',
          items: 'Choose the product with the problem.',
        },
      },
    };
    // Matches lib/support.ts in the dashboard: which types need photos / a refund destination / a wish.
    const DEF = {
      damaged: { photos: true, resolution: true, h: 48, sla: 4 },
      wrong_item: { photos: true, resolution: true, h: 48, sla: 4 },
      return: { refund: true, h: 48, sla: 24 },
      exchange: { wish: true, h: 336, sla: 24 },
      authenticity: { photos: true, resolution: true, sla: 12 },
      delivery: { sla: 4 },
      cancel_edit: { wish: true, sla: 2 },
      refund_missing: { refund: true, sla: 12 },
      complaint: { sla: 24 },
    };
    const MAX_PHOTOS = 4;

    /** Resize in the browser (max 1600 px, JPEG) so uploads stay small on mobile data. */
    async function shrink(file) {
      try {
        const bmp = await createImageBitmap(file);
        const scale = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
        const c = document.createElement('canvas');
        c.width = Math.round(bmp.width * scale);
        c.height = Math.round(bmp.height * scale);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        const blob = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.82));
        if (blob) return new File([blob], 'photo.jpg', { type: 'image/jpeg' });
      } catch (e) { /* fall through: send the original if the browser can't decode it */ }
      return file;
    }

    const store = {
      get(k) { try { return sessionStorage.getItem(`cl-sp:${k}`) || ''; } catch (e) { return ''; } },
      set(k, v) { try { sessionStorage.setItem(`cl-sp:${k}`, v); } catch (e) { /* private mode */ } },
    };

    class ClSupport extends HTMLElement {
      connectedCallback() {
        this.lang = this.dataset.lang === 'en' ? 'en' : 'ar';
        this.t = T[this.lang];
        this.api = (this.dataset.api || '').replace(/\/+$/, '');
        this.files = [];
        this.state = {};
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((b) => {
          b.addEventListener('click', () => this.tab(b.dataset.tab));
          b.addEventListener('keydown', (e) => {
            if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
            const next = this.tabs.find((x) => x !== b);
            next.focus();
            this.tab(next.dataset.tab);
          });
        });
        this.querySelector('[data-form="verify"]').addEventListener('submit', (e) => { e.preventDefault(); this.verify(e.currentTarget); });
        this.querySelector('[data-form="track"]').addEventListener('submit', (e) => { e.preventDefault(); this.track(e.currentTarget); });
        // Remembered for this browser tab only (the customer may switch between "new" and "track").
        const phone = store.get('phone');
        if (phone) this.querySelectorAll('input[name="phone"]').forEach((i) => { i.value = phone; });
        const orderNo = store.get('order');
        if (orderNo) this.querySelector('[data-form="track"] input[name="code"]').value = orderNo;
        if (location.hash === '#track') this.tab('track');
      }

      tab(name) {
        this.tabs.forEach((b) => {
          const on = b.dataset.tab === name;
          b.setAttribute('aria-selected', String(on));
          b.tabIndex = on ? 0 : -1;
          this.querySelector(`#${b.getAttribute('aria-controls')}`).hidden = !on;
        });
      }

      step(name) {
        this.querySelectorAll('#cl-sp-new [data-step]').forEach((s) => { s.hidden = s.dataset.step !== name; });
        const n = { verify: 1, type: 2, details: 3, done: 4 }[name];
        this.querySelectorAll('.cl-sp__steps li').forEach((li) => {
          const i = Number(li.dataset.n);
          li.classList.toggle('is-on', i === n);
          li.classList.toggle('is-done', i < n);
        });
        const sec = this.querySelector(`[data-step="${name}"]`);
        const h = sec.querySelector('h2, h3');
        if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); }
        if (sec.getBoundingClientRect().top < 0) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      error(form, key) {
        const p = form.querySelector('.cl-sp__error');
        const msg = this.t.err[key] || this.t.err.server;
        p.textContent = msg;
        p.hidden = !key;
        if (key) p.focus?.();
      }

      async call(op, body) {
        if (!this.api) return { ok: false, error: 'server' };
        try {
          const r = await fetch(`${this.api}/api/support/${op}`, body instanceof FormData
            ? { method: 'POST', body }
            : { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
          return await r.json().catch(() => ({ ok: false, error: 'server' }));
        } catch (e) {
          return { ok: false, error: 'network' };
        }
      }

      busy(btn, on, label) {
        btn.disabled = on;
        if (on) { btn.dataset.label = btn.textContent; btn.textContent = label || '…'; }
        else if (btn.dataset.label) btn.textContent = btn.dataset.label;
      }

      async verify(form) {
        const order = form.order.value.trim(), phone = form.phone.value.trim();
        if (!order || !phone) return this.error(form, 'need');
        this.error(form, '');
        const btn = form.querySelector('button[type="submit"]');
        this.busy(btn, true);
        const r = await this.call('lookup', { order, phone });
        this.busy(btn, false);
        if (!r.ok) return this.error(form, r.error);
        store.set('phone', phone);
        this.state = { order: r.order, open: r.open || [], phone };
        this.renderTypes();
        this.step('type');
      }

      renderTypes() {
        const { order, open } = this.state, t = this.t;
        const sec = this.querySelector('[data-step="type"]');
        const openList = open.map((o) => `<b dir="ltr">${esc(o.code)}</b> (${esc(t.types[o.type]?.[0] || o.type)})`).join('، ');
        sec.innerHTML = `
          <button type="button" class="cl-sp__back" data-back="verify"><span class="cl-sp__arrow">${svg('arrow').replace('<svg', '<svg width="16" height="16"')}</span>${t.back}</button>
          <p class="cl-sp__hello">${esc(t.hello(order.firstName, order.order))}</p>
          <h2 class="cl-sp__h2">${t.typeTitle}</h2>
          ${open.length ? `<p class="cl-sp__note" style="margin-block:12px 18px">${t.openNote(openList)}</p>` : '<div style="height:14px"></div>'}
          <ul class="cl-sp__types" role="list">
            ${ORDER.map((k) => {
              const w = order.windows[k] || {};
              return `<li><button type="button" class="cl-sp__type" data-type="${k}">
                ${svg(k)}<b>${esc(t.types[k][0])}</b><small>${esc(t.types[k][1])}</small>
                ${w.outside && k !== 'cancel_edit' ? `<span class="cl-sp__badge">${t.late}</span>` : ''}
              </button></li>`;
            }).join('')}
          </ul>`;
        sec.querySelector('[data-back]').addEventListener('click', () => this.step('verify'));
        sec.querySelectorAll('[data-type]').forEach((b) => b.addEventListener('click', () => { this.renderDetails(b.dataset.type); this.step('details'); }));
      }

      renderDetails(type) {
        const t = this.t, d = DEF[type], { order } = this.state;
        const w = order.windows[type] || {};
        this.state.type = type;
        this.files = [];
        const fmtDate = (iso) => new Date(iso).toLocaleDateString(this.lang === 'ar' ? 'ar-EG' : 'en-GB', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
        let notice = '';
        if (type === 'cancel_edit' && w.outside) notice = `<p class="cl-sp__note cl-sp__note--warn">${t.shipped}</p>`;
        else if (w.outside) notice = `<p class="cl-sp__note cl-sp__note--warn">${t.windowOut(t.winH(d.h))} <a href="${esc(this.dataset.policy)}" target="_blank" rel="noopener">↗</a></p>`;
        else if (w.until) notice = `<p class="cl-sp__note">${t.windowIn(fmtDate(w.until))}</p>`;
        const many = order.items.length > 1;
        const items = order.items.map((it, i) => `
          <label class="cl-sp__opt">
            <input type="${many ? 'checkbox' : 'radio'}" name="items" value="${i}" ${many ? '' : 'checked'}>
            ${it.image ? `<img src="${esc(it.image)}" alt="" width="44" height="44" loading="lazy">` : ''}
            <span>${esc(it.title)}${it.variant || it.qty > 1 ? `<small>${esc([it.variant, it.qty > 1 ? `×${it.qty}` : ''].filter(Boolean).join(' · '))}</small>` : ''}</span>
          </label>`).join('');
        const pills = (name, obj, first) => `<div class="cl-sp__pills">${Object.entries(obj).map(([v, l], i) =>
          `<label class="cl-sp__opt"><input type="radio" name="${name}" value="${v}" ${first && i === 0 ? 'checked' : ''}><span>${esc(l)}</span></label>`).join('')}</div>`;
        const sec = this.querySelector('[data-step="details"]');
        sec.innerHTML = `
          <button type="button" class="cl-sp__back" data-back="type"><span class="cl-sp__arrow">${svg('arrow').replace('<svg', '<svg width="16" height="16"')}</span>${t.back}</button>
          <div class="cl-sp__chosen">${svg(type)}<div><h2 class="cl-sp__h2" style="margin:0;font-size:17px !important">${esc(t.types[type][0])}</h2><small dir="auto">${esc(order.order)}</small></div></div>
          <form class="cl-sp__form" data-form="details" novalidate>
            ${notice}
            ${order.items.length ? `<fieldset class="cl-sp__fieldset"><legend>${t.items}</legend><div class="cl-sp__items">${items}</div></fieldset>` : ''}
            ${d.wish ? `<label class="cl-sp__field"><span>${type === 'exchange' ? t.wishExchange : t.wishCancel}</span><input name="wish" type="text" maxlength="300" placeholder="${esc(type === 'exchange' ? t.wishExchangePh : t.wishCancelPh)}"></label>` : ''}
            ${d.resolution ? `<fieldset class="cl-sp__fieldset"><legend>${t.resolution}</legend>${pills('resolution', t.res, true)}</fieldset>` : ''}
            <div data-refund ${d.refund ? '' : 'hidden'}>
              <fieldset class="cl-sp__fieldset"><legend>${t.refund}</legend>${pills('refund_method', t.refundMethods, true)}</fieldset>
              <label class="cl-sp__field" style="margin-top:12px"><span>${t.account}</span><input name="refund_account" type="text" dir="ltr" maxlength="60" placeholder="${esc(t.accountPh)}" autocomplete="off"></label>
            </div>
            <label class="cl-sp__field"><span>${t.details}</span><textarea name="details" rows="5" maxlength="3000" placeholder="${esc(t.detailsPh)}" required></textarea></label>
            <div class="cl-sp__fieldset">
              <span class="cl-sp__field"><span>${t.photos} <b>${d.photos ? t.photosReq : t.photosOpt}</b></span></span>
              ${t.photosHint[type] ? `<small class="cl-sp__hint" style="margin:0">${t.photosHint[type]}</small>` : ''}
              <label class="cl-sp__drop" data-drop><span>${t.drop}</span>
                <input type="file" accept="image/jpeg,image/png,image/webp,image/*" multiple data-photos>
              </label>
              <ul class="cl-sp__thumbs" role="list" data-thumbs></ul>
            </div>
            <div class="cl-sp__row">
              <label class="cl-sp__field"><span>${t.name}</span><input name="name" type="text" autocomplete="name" maxlength="80" value="${esc(order.firstName)}" required></label>
              <fieldset class="cl-sp__fieldset"><legend>${t.contact}</legend>${pills('contact_pref', t.contacts, true)}</fieldset>
            </div>
            <label class="cl-sp__hp" aria-hidden="true">Website <input name="website" type="text" tabindex="-1" autocomplete="off"></label>
            <p class="cl-sp__error" role="alert" tabindex="-1" hidden></p>
            <button type="submit" class="cl-sp__btn">${t.submit}</button>
          </form>`;
        sec.querySelector('[data-back]').addEventListener('click', () => this.step('type'));
        const form = sec.querySelector('form');
        const refundBox = form.querySelector('[data-refund]');
        form.querySelectorAll('input[name="resolution"]').forEach((r) => r.addEventListener('change', () => { refundBox.hidden = !(d.refund || form.resolution.value === 'refund'); }));
        const input = form.querySelector('[data-photos]');
        input.addEventListener('change', () => { this.addFiles(input.files, form); input.value = ''; });
        const drop = form.querySelector('[data-drop]');
        drop.addEventListener('dragover', (e) => e.preventDefault());
        drop.addEventListener('drop', (e) => { e.preventDefault(); this.addFiles(e.dataTransfer.files, form); });
        form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(form); });
      }

      async addFiles(list, form) {
        const files = form._files || this.files;
        const max = form._files ? 3 : MAX_PHOTOS;
        for (const f of [...list]) {
          if (files.length >= max) break;
          if (!/^image\//.test(f.type)) continue;
          files.push(await shrink(f));
        }
        this.renderThumbs(form);
      }

      renderThumbs(form) {
        const ul = form.querySelector('[data-thumbs]');
        ul.querySelectorAll('img').forEach((img) => URL.revokeObjectURL(img.src));
        const files = form._files || this.files;
        ul.innerHTML = files.map((f, i) => `<li><img src="${URL.createObjectURL(f)}" alt=""><button type="button" data-rm="${i}" aria-label="×">×</button></li>`).join('');
        ul.querySelectorAll('[data-rm]').forEach((b) => b.addEventListener('click', () => { files.splice(Number(b.dataset.rm), 1); this.renderThumbs(form); }));
      }

      async submit(form) {
        const { type, order, phone } = this.state, d = DEF[type];
        const picked = [...form.querySelectorAll('input[name="items"]:checked')].map((i) => i.value);
        if (order.items.length > 1 && !picked.length && ['damaged', 'wrong_item', 'return', 'exchange', 'authenticity'].includes(type)) return this.error(form, 'items');
        if (d.photos && !this.files.length) return this.error(form, 'photos_required');
        const fd = new FormData(form);
        fd.delete('items');
        fd.set('items', picked.join(','));
        fd.set('type', type);
        fd.set('order', order.order);
        fd.set('phone', phone);
        fd.set('lang', this.lang);
        if (!(d.refund || fd.get('resolution') === 'refund')) { fd.delete('refund_method'); fd.delete('refund_account'); }
        this.files.forEach((f) => fd.append('photos', f, f.name || 'photo.jpg'));
        this.error(form, '');
        const btn = form.querySelector('button[type="submit"]');
        this.busy(btn, true, this.t.sending);
        const r = await this.call('create', fd);
        this.busy(btn, false);
        if (!r.ok) return this.error(form, r.error);
        this.renderDone(r);
        this.step('done');
      }

      renderDone(r) {
        const t = this.t;
        const orderNo = String(this.state.order.order || '').replace('#', '');
        store.set('order', orderNo);
        const sec = this.querySelector('[data-step="done"]');
        sec.innerHTML = `
          <div class="cl-sp__done">
            <span class="cl-sp__done-icon">${svg('check')}</span>
            <h2 class="cl-sp__h2">${t.doneTitle}</h2>
            ${r.existing ? `<p>${t.doneExisting}</p>` : ''}
            <p>${t.doneText(t.hours(r.slaH || DEF[this.state.type].sla))}</p>
            <p class="cl-sp__ref">${t.ref} <b dir="ltr">${esc(r.code)}</b></p>
            <div class="cl-sp__actions">
              <button type="button" class="cl-sp__btn" data-go-track>${t.trackIt}</button>
              <button type="button" class="cl-sp__btn cl-sp__btn--ghost" data-new>${t.newOne}</button>
            </div>
          </div>`;
        sec.querySelector('[data-go-track]').addEventListener('click', () => {
          const f = this.querySelector('[data-form="track"]');
          f.code.value = orderNo;
          f.phone.value = this.state.phone;
          this.tab('track');
          this.track(f);
        });
        sec.querySelector('[data-new]').addEventListener('click', () => this.step('type'));
      }

      async track(form) {
        const query = form.code.value.trim(), phone = form.phone.value.trim();
        if (!query || !phone) return this.error(form, 'needTrack');
        this.error(form, '');
        const btn = form.querySelector('button[type="submit"]');
        this.busy(btn, true);
        const r = await this.call('status', { code: query, phone });
        this.busy(btn, false);
        if (!r.ok) return this.error(form, r.error === 'no_match' ? 'no_match_track' : r.error);
        store.set('phone', phone);
        store.set('order', query);
        this.renderStatus(r.tickets || [r.ticket], phone);
        this.watch(query, phone);
      }

      /** Live updates: while the tracking result is on screen (and the tab is visible) ask every 15 s for changes,
       *  and refresh the timelines in place so a half-written reply is never lost. */
      watch(query, phone) {
        clearInterval(this.timer);
        const tick = async () => {
          if (document.visibilityState !== 'visible' || this.querySelector('#cl-sp-track').hidden) return;
          const r = await this.call('status', { code: query, phone });
          if (!r.ok) return;
          const list = r.tickets || [r.ticket];
          const json = JSON.stringify(list);
          if (json === this.lastJson) return;
          const key = (l) => (l || []).map((k) => `${k.code}:${k.open}`).join();
          const sameSet = key(list) === key(this.lastList);
          if (!sameSet && this.hasDraft()) return;
          if (sameSet) list.forEach((k) => this.updateBlock(k));
          else this.renderStatus(list, phone, true);
          this.lastJson = json;
          this.lastList = list;
        };
        this.timer = setInterval(tick, 15000);
        if (!this.onVisible) {
          this.onVisible = () => { if (document.visibilityState === 'visible' && this.timer) tick(); };
          document.addEventListener('visibilitychange', this.onVisible);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
      }

      hasDraft() {
        return [...this.querySelectorAll('[data-form="reply"]')].some((f) => f.text.value.trim() || (f._files || []).length);
      }

      when(iso) {
        return new Date(iso).toLocaleString(this.lang === 'ar' ? 'ar-EG' : 'en-GB', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
      }

      timeline(k) {
        const t = this.t;
        // Photos come as signed paths on the support API (e.g. the refund transfer receipt from our team).
        const pics = (e) => ((e.photos || []).length ? `<span class="cl-sp__pics">${e.photos.map((u) => `<a href="${esc(this.api + u)}" target="_blank" rel="noopener"><img src="${esc(this.api + u)}" alt="" width="88" height="88" loading="lazy"></a>`).join('')}</span>` : '');
        const line = (e) => {
          if (e.kind === 'created') return `<li><b>${t.created}</b><time>${this.when(e.at)}</time>${pics(e)}</li>`;
          if (e.kind === 'customer') return `<li class="is-you"><b>${t.you}</b><time>${this.when(e.at)}</time>${e.text ? `<p dir="auto">${esc(e.text)}</p>` : ''}${pics(e)}</li>`;
          const title = e.kind === 'status' ? (t.status[e.status] || e.status) : t.team;
          return `<li><b>${esc(title)}</b><time>${this.when(e.at)}</time>${e.text ? `<p dir="auto">${esc(e.text)}</p>` : ''}${pics(e)}</li>`;
        };
        return k.events.map(line).join('');
      }

      pill(k) {
        const tone = k.status === 'resolved' ? ' cl-sp__pill--ok' : k.status === 'needs_info' ? ' cl-sp__pill--warn' : '';
        return `<span class="cl-sp__pill${tone}">${esc(this.t.status[k.status] || k.status)}</span>`;
      }

      updateBlock(k) {
        const block = this.querySelector(`.cl-sp__status[data-code="${k.code}"]`);
        if (!block) return;
        const tl = block.querySelector('[data-tl]');
        const before = tl.children.length;
        tl.innerHTML = this.timeline(k);
        block.querySelector('[data-pill]').innerHTML = this.pill(k);
        if (tl.children.length > before) {
          tl.lastElementChild.classList.add('is-new');
          block.querySelector('[data-live]').textContent = this.t.liveNew;
        }
      }

      renderStatus(list, phone, quiet = false) {
        const t = this.t, box = this.querySelector('[data-track-result]');
        this.lastJson = JSON.stringify(list);
        this.lastList = list;
        box.innerHTML = list.map((k) => `
          <div class="cl-sp__status" data-code="${esc(k.code)}" tabindex="-1">
            <div class="cl-sp__status-head"><b>${esc(t.types[k.type]?.[0] || '')}</b><span data-pill>${this.pill(k)}</span></div>
            <p class="cl-sp__meta"><span dir="ltr">${esc(k.order)}</span>${k.items.length ? ` · ${esc(k.items.join('، '))}` : ''} · ${t.ref} <span dir="ltr">${esc(k.code)}</span></p>
            <p class="cl-sp__live" role="status" data-live></p>
            <ol class="cl-sp__timeline" data-tl>${this.timeline(k)}</ol>
            ${k.open ? `
              <form class="cl-sp__form" data-form="reply" novalidate>
                <label class="cl-sp__field"><span>${t.addTitle}</span><textarea name="text" rows="3" maxlength="3000" placeholder="${esc(t.addPh)}"></textarea></label>
                <label class="cl-sp__drop" data-drop><span>${t.drop}</span><input type="file" accept="image/jpeg,image/png,image/webp,image/*" multiple data-photos></label>
                <ul class="cl-sp__thumbs" role="list" data-thumbs></ul>
                <p class="cl-sp__error" role="alert" tabindex="-1" hidden></p>
                <button type="submit" class="cl-sp__btn cl-sp__btn--ghost">${t.addSend}</button>
              </form>` : `<p class="cl-sp__note">${t.closed}</p>`}
          </div>`).join('');
        if (!quiet) box.querySelector('.cl-sp__status')?.focus({ preventScroll: true });
        box.querySelectorAll('[data-form="reply"]').forEach((form) => {
          const code = form.closest('[data-code]').dataset.code;
          form._files = [];
          const input = form.querySelector('[data-photos]');
          input.addEventListener('change', () => { this.addFiles(input.files, form); input.value = ''; });
          const drop = form.querySelector('[data-drop]');
          drop.addEventListener('dragover', (e) => e.preventDefault());
          drop.addEventListener('drop', (e) => { e.preventDefault(); this.addFiles(e.dataTransfer.files, form); });
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (!form.text.value.trim() && !form._files.length) return this.error(form, 'empty');
            const fd = new FormData();
            fd.set('code', code);
            fd.set('phone', phone);
            fd.set('text', form.text.value);
            form._files.slice(0, 3).forEach((f) => fd.append('photos', f, f.name || 'photo.jpg'));
            const btn = form.querySelector('button[type="submit"]');
            this.busy(btn, true, t.sending);
            const r = await this.call('reply', fd);
            this.busy(btn, false);
            if (!r.ok) return this.error(form, r.error);
            form.text.value = '';
            form._files = [];
            this.renderThumbs(form);
            this.error(form, '');
            this.updateBlock(r.ticket);
            form.closest('[data-code]').querySelector('[data-live]').textContent = t.addDone;
            this.lastList = (this.lastList || []).map((k) => (k.code === r.ticket.code ? r.ticket : k));
            this.lastJson = JSON.stringify(this.lastList);
          });
        });
      }
    }

    customElements.define('cl-support', ClSupport);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-tabbar"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hides the tab bar while the shopper scrolls down and brings it back on the way up, near the end of
   * the page, or when something inside it takes focus. Transform only; reduced motion keeps it in place.
   */
  class ClTabbar extends HTMLElement {
    #lastY = 0;
    #queued = false;
    #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#lastY = window.scrollY;
      if (this.hasAttribute('data-hide-on-scroll')) {
        window.addEventListener('scroll', this.#onScroll, { passive: true });
      }
      this.addEventListener('focusin', this.reveal);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.#onScroll);
      this.removeEventListener('focusin', this.reveal);
    }

    #onScroll = () => {
      if (this.#queued) return;
      this.#queued = true;
      window.requestAnimationFrame(this.#update);
    };

    #update = () => {
      this.#queued = false;
      if (this.#reducedMotion.matches) {
        this.reveal();
        return;
      }

      const y = window.scrollY;
      const delta = y - this.#lastY;
      if (Math.abs(delta) < 8) return;

      const nearEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 160;
      if (delta > 0 && y > 120 && !nearEnd) {
        this.classList.add('is-hidden');
      } else {
        this.reveal();
      }
      this.#lastY = y;
    };

    /** Shows the bar (also used by assets/cl-delight.js before flying into the cart tab). */
    reveal = () => {
      this.classList.remove('is-hidden');
    };
  }

  if (!customElements.get('cl-tabbar')) customElements.define('cl-tabbar', ClTabbar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
